// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Component Styles */

.home-container {
    max-width: 1400px;
    font-size: 14px;
    color: #333;
}

/* Banner Styles */
.banner-wrapper {
    max-height: 40%;
    background-color: #e0e0e0;
}

.banner-image {
    object-fit: cover;
}

.banner-text-overlay {
    background: rgba(211, 211, 211, 0.85);
    width: 40%;
}

.banner-link {
    color: #0066B2;
    font-size: 16px;
}

.text-primary-blue {
    color: #0066B2;
}

.text-primary-cyan {
    color: #009DD9;
}

.text-muted-gray {
    color: #666;
}

.text-size-sm {
    font-size: 13px;
}

.text-size-base {
    font-size: 14px;
}

.text-size-md {
    font-size: 16px;
}

.text-size-lg {
    font-size: 18px;
}

.text-justify {
    text-align: justify;
}

.line-height-relaxed {
    line-height: 1.6;
}

/* Headings */
.section-heading {
    color: #009DD9;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
}

.sidebar-heading {
    font-size: 13px;
    letter-spacing: 0.5px;
    text-align: left;
}

/* Links */
.link-primary {
    color: #0066B2;
    font-size: 14px;
}

.link-sm {
    color: #0066B2;
    font-size: 12px;
}

/* List Items */
.list-item-arrow {
    padding-left: 14px;
    text-indent: -14px;
}

.list-item-arrow-sm {
    padding-left: 12px;
    text-indent: -12px;
}

.arrow-icon {
    color: #009DD9;
    font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/home/home.component.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":["/* Home Component Styles */\n\n.home-container {\n    max-width: 1400px;\n    font-size: 14px;\n    color: #333;\n}\n\n/* Banner Styles */\n.banner-wrapper {\n    max-height: 40%;\n    background-color: #e0e0e0;\n}\n\n.banner-image {\n    object-fit: cover;\n}\n\n.banner-text-overlay {\n    background: rgba(211, 211, 211, 0.85);\n    width: 40%;\n}\n\n.banner-link {\n    color: #0066B2;\n    font-size: 16px;\n}\n\n.text-primary-blue {\n    color: #0066B2;\n}\n\n.text-primary-cyan {\n    color: #009DD9;\n}\n\n.text-muted-gray {\n    color: #666;\n}\n\n.text-size-sm {\n    font-size: 13px;\n}\n\n.text-size-base {\n    font-size: 14px;\n}\n\n.text-size-md {\n    font-size: 16px;\n}\n\n.text-size-lg {\n    font-size: 18px;\n}\n\n.text-justify {\n    text-align: justify;\n}\n\n.line-height-relaxed {\n    line-height: 1.6;\n}\n\n/* Headings */\n.section-heading {\n    color: #009DD9;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: left;\n}\n\n.sidebar-heading {\n    font-size: 13px;\n    letter-spacing: 0.5px;\n    text-align: left;\n}\n\n/* Links */\n.link-primary {\n    color: #0066B2;\n    font-size: 14px;\n}\n\n.link-sm {\n    color: #0066B2;\n    font-size: 12px;\n}\n\n/* List Items */\n.list-item-arrow {\n    padding-left: 14px;\n    text-indent: -14px;\n}\n\n.list-item-arrow-sm {\n    padding-left: 12px;\n    text-indent: -12px;\n}\n\n.arrow-icon {\n    color: #009DD9;\n    font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
